
import { notifySuccess, notifyError } from '../components/Toast';
import { getAllExternalJury } from './proposalActions';

export const loginUser = (credentials) => {
    return async (dispatch) => {
        dispatch({ type: 'USER_LOGIN_REQUEST' });

        let payload = {
            returnurl: "URL_DASHBOARD",
            username: credentials.username,
            password: credentials.password,
            appid: "microcredencial"
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_LOGIN_URL}`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Credenciales inválidas');
            }

            const user = await response.json();

            dispatch({ type: 'USER_LOGIN_SUCCESS', payload: user });
        } catch (error) {
            dispatch({ type: 'USER_LOGIN_FAIL', payload: error.message });
        }
    };
};

/*export const loginExternalUser = (credentials) => {
    return async (dispatch) => {
        dispatch({ type: 'USER_LOGIN_REQUEST' });

        let payload = {            
            mail: credentials.username,
            password: credentials.password,
            appid: "microcredencial"
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/microcredenciales/usuarios/login`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Credenciales inválidas');
            }

            const user = await response.json();

            // Verificar si la autenticación fue exitosa
            if (user.Authenticated === false) {
                // Extraer el mensaje de error del HTML si existe
                let errorMessage = 'Usuario o password incorrecto';
                if (user.Message) {
                    // Remover tags HTML y limpiar el mensaje
                    errorMessage = user.Message.replace(/<[^>]*>/g, '').trim();
                    if (errorMessage.toLowerCase().includes('usuario') || errorMessage.toLowerCase().includes('password')) {
                        errorMessage = 'Usuario o contraseña incorrectos';
                    }
                }
                throw new Error(errorMessage);
            }

            dispatch({ type: 'USER_LOGIN_SUCCESS', payload: user });
        } catch (error) {
            dispatch({ type: 'USER_LOGIN_FAIL', payload: error.message });
        }
    };
};*/

export const sendOtpForLogin = (mail) => {
    return async (dispatch) => {
        dispatch({ type: 'SEND_OTP_LOGIN_REQUEST' });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/usuarios/externo/ingreso`, {
                method: 'POST',
                body: JSON.stringify(mail),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Error al enviar OTP');
            }

            const result = await response.json();

            dispatch({ type: 'SEND_OTP_LOGIN_SUCCESS', payload: result });
            notifySuccess('OTP enviado a tu email. Ingresa el código para continuar.');
        } catch (error) {
            dispatch({ type: 'SEND_OTP_LOGIN_FAIL', payload: error.message });
            notifyError(error.message);
        }
    };
};

export const validateLoginOtp = (credentials) => {
    return async (dispatch) => {
        dispatch({ type: 'VALIDATE_LOGIN_OTP_REQUEST' });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/usuarios/externo/ingreso/validar`, {
                method: 'POST',
                body: JSON.stringify(credentials),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Validación fallida');
            }

            const user = await response.json();

            // Verificar si la autenticación fue exitosa
            if (user.authenticated === false) {
                throw new Error('OTP inválido');
            }

            dispatch({ type: 'VALIDATE_LOGIN_OTP_SUCCESS', payload: user });
            notifySuccess('Login exitoso. Bienvenido!');
        } catch (error) {
            dispatch({ type: 'VALIDATE_LOGIN_OTP_FAIL', payload: error.message });
            notifyError(error.message);
        }
    };
};

export const logoutUser = () => ({
    type: 'USER_LOGOUT',
});

export const createExternalUser = (userData, user, proposalId) => async (dispatch) => {
    try {
        dispatch({ type: 'CREATE_EXTERNAL_USER' });
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/usuarios/externo`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token
            },
            body: JSON.stringify(userData),
        });

        if (response.ok) {
            dispatch({ type: 'CREATE_EXTERNAL_USER_SUCCESS' });
            dispatch(getAllExternalJury(user));
            notifySuccess('Usuario externo registrado exitosamente!')
        } else {
            const errorData = await response.statusText;
            notifyError('Error al registrar usuario externo');
            dispatch({ type: 'CREATE_EXTERNAL_USER_FAIL', payload: errorData });
        }
    } catch (error) {
        notifyError('Error al registrar usuario externo');
        dispatch({ type: 'CREATE_EXTERNAL_USER_ERROR', payload: error.message });
    }
};

export const registerExternalUser = (userData) => {
    return async (dispatch) => {
        dispatch({ type: 'REGISTER_EXTERNAL_USER_REQUEST' });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/microcredenciales/usuarios/externo/registro`, {
                method: 'POST',
                body: JSON.stringify(userData),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Error en el registro');
            }

            const result = await response.json();

            dispatch({ type: 'REGISTER_EXTERNAL_USER_SUCCESS', payload: result });
            notifySuccess('Registro exitoso. Revisa tu email para validar la cuenta.');
        } catch (error) {
            dispatch({ type: 'REGISTER_EXTERNAL_USER_FAIL', payload: error.message });
            notifyError(error.message);
        }
    };
};

export const validateExternalUser = (credentials) => {
    return async (dispatch) => {
        dispatch({ type: 'VALIDATE_EXTERNAL_USER_REQUEST' });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/microcredenciales/usuarios/externo/registro/validar`, {
                method: 'POST',
                body: JSON.stringify(credentials),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Validación fallida');
            }

            const user = await response.json();

            // Verificar si la autenticación fue exitosa
            if (user.authenticated === false) {
                throw new Error('Validación fallida');
            }

            dispatch({ type: 'VALIDATE_EXTERNAL_USER_SUCCESS', payload: user });
            notifySuccess('Validación exitosa. Bienvenido!');
        } catch (error) {
            dispatch({ type: 'VALIDATE_EXTERNAL_USER_FAIL', payload: error.message });
            notifyError(error.message);
        }
    };
};

